import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import LazyImage from 'dibs-react-lazy-image';
import TrackingCarousel from '../../components/global/TrackingCarousel';
import {
    trackInitialDisplay,
    trackArrowClick,
    trackItemClick,
    trackRecentItem,
} from '../helpers/recentlyViewedItemsTrackingHelpers';

const OFFSET_IMAGE_VERTICAL = 600;
const OFFSET_IMAGE_HORIZONTAL = 300;

class PdpRespRecentlyViewedItemsCarousel extends Component {
    constructor() {
        super();

        this.handleInitialDisplay = this.handleInitialDisplay.bind(this);
        this.renderCarouselItem = this.renderCarouselItem.bind(this);
    }

    handleInitialDisplay() {
        const { items } = this.props;
        const itemsReturned = items.length;
        trackInitialDisplay({ itemsReturned });
    }

    handleItemClick({ item, index }) {
        trackItemClick();
        trackRecentItem({
            type: 'productClick',
            item,
            position: index + 1, // Tracking needs non zero index position.
        });
    }

    handleItemImpression({ item, index }) {
        trackRecentItem({
            type: 'productImpression',
            item,
            position: index + 1, // Tracking needs non zero index position.
        });
    }

    renderCarouselItem({ index }) {
        const { items, classNames } = this.props;
        const item = items[index];

        return (
            <a
                key={`recent-${item.itemId}`}
                href={item.itemPdpUrl}
                onClick={() => this.handleItemClick({ item, index })}
                className={classNames.itemLink}
            >
                <LazyImage
                    offsetHorizontal={OFFSET_IMAGE_HORIZONTAL}
                    offsetVertical={OFFSET_IMAGE_VERTICAL}
                    placeholderClass={classNames.placeholder}
                >
                    <img
                        className={classNames.itemImage}
                        src={get(item.itemImageUrl, 'src') || item.itemImageUrl}
                        alt={item.itemTitle}
                    />
                </LazyImage>
            </a>
        );
    }

    render() {
        const { items, itemsPerPage } = this.props;

        return (
            <TrackingCarousel
                items={items}
                renderItem={this.renderCarouselItem}
                itemsPerPage={itemsPerPage}
                onInitialDisplay={this.handleInitialDisplay}
                onItemImpression={this.handleItemImpression}
                onNextPage={() => trackArrowClick({ direction: 'right' })}
                onPreviousPage={() => trackArrowClick({ direction: 'left' })}
            />
        );
    }
}

PdpRespRecentlyViewedItemsCarousel.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            contemporaryTrackingString: PropTypes.string,
            itemTitle: PropTypes.string.isRequired,
            itemId: PropTypes.string.isRequired,
            itemImageUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
            itemPdpUrl: PropTypes.string.isRequired,
            dealerPk: PropTypes.string.isRequired,
            category: PropTypes.string.isRequired,
        })
    ).isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    classNames: PropTypes.shape({
        placeholder: PropTypes.string.isRequired,
        itemLink: PropTypes.string.isRequired,
        itemImage: PropTypes.string.isRequired,
    }).isRequired,
};

export default PdpRespRecentlyViewedItemsCarousel;
